import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="course-informations"
export default class extends Controller {
  static targets = [ "switchFlag", "switchField" ]

  connect() {
    this.changeClassList(this.switchFlagTarget.value == 'specified')
  }

  switchDateField(event) {
    this.changeClassList(event.target.value == 'specified')
  }

  changeClassList(isDisplay) {
    if (isDisplay) {
      this.switchFieldTarget.classList.remove('d-none')
    } else {
      this.switchFieldTarget.classList.add('d-none')
    }
  }
}
